import { createStore, applyMiddleware } from 'redux';
import { rootReducer } from './reducer';
import { createLogger } from 'redux-logger';

export const store =
  window.location.hostname === 'localhost'
    ? createStore(rootReducer, applyMiddleware(createLogger()))
    : createStore(rootReducer);
